<template>
  <div class="home-page">
    <div class="content">
    <!-- 左侧：照片轮播 -->
    <div class="photo-carousel">
      <img :src="currentPhoto" alt="Current Photo" />
    </div>

    <!-- 右侧：小窗口列表 -->
    <div class="window-list">
      <div
        class="window-item"
        v-for="(item, index) in windowItems"
        :key="index"
        @click="navigateToView5(item.robotId)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      photos: [
        require('@/assets/image/1.png'),
        require('@/assets/image/2.png'),
        require('@/assets/image/3.png'),
        require('@/assets/image/4.png'),
      ],
      currentPhotoIndex: 0,
      photoInterval: null,
      windowItems: [
        { name: "图灵楼下机器人1大屏", robotId: 3 },
        { name: "图灵楼下机器人2大屏", robotId: 4 },
        { name: "雄安科创地下停车场机器人大屏", robotId: 5 },
        // { name: "机器人3大屏", robotId: 3 },
        // { name: "机器人4大屏", robotId: 4 }
      ]
    };
  },
  computed: {
    currentPhoto() {
      return this.photos[this.currentPhotoIndex];
    }
  },
  mounted() {
    this.startPhotoCarousel();
  },
  beforeDestroy() {
    // 清除定时器
    if (this.photoInterval) {
      clearInterval(this.photoInterval);
    }
  },
  methods: {
    startPhotoCarousel() {
      this.photoInterval = setInterval(() => {
        this.currentPhotoIndex = (this.currentPhotoIndex + 1) % this.photos.length;
      }, 2000);
    },
    navigateToView5(robotId) {
      this.$router.push({ name: 'view5', query: { robotId } });
    }
  }
};
</script>

<style scoped>
.home-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;  /* 使页面内容至少占满屏幕 */
}
.content {
  display: flex;
  justify-content: space-between;
  align-items: center;  /* 保证左右两部分居中 */
  width: 80%; /* 宽度设置为页面宽度的80% */
  max-width: 1200px; /* 最大宽度控制 */
  gap: 30px; /* 左右间距 */
  flex-wrap: wrap; /* 允许在小屏幕上换行 */
}

.photo-carousel {
  width: 50%;
  height: 400px;
  background-color: rgba(240, 240, 240, 0);
  display: flex;
  justify-content: center;
  align-items: center;
}

.photo-carousel img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.window-list {
  width: 45%;
  display: flex;
  flex-direction: column;
}

.window-item {
  background-color: #007bff;
  color: white;
  padding: 20px;
  margin: 10px 0;
  cursor: pointer;
  text-align: center;
  font-size: 18px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.window-item:hover {
  background-color: #0056b3;
}
</style>
